


























































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { ThemeConfig } from "@/plugins/config";

@Component({
  name: "demo-login",
})
export default class DemoLogin extends Vue {
  @Getter("theme")
  public theme!: ThemeConfig;
}
